// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AddExperienceToFavoriteData,
  AddExperienceToFavoriteErrors,
  AddExperienceToFavoriteResponses,
  GetAttractionCommentsData,
  GetAttractionCommentsErrors,
  GetAttractionCommentsResponses,
  GetCitiesAroundData,
  GetCitiesAroundErrors,
  GetCitiesAroundResponses,
  GetCitiesAroundSeoData,
  GetCitiesAroundSeoErrors,
  GetCitiesAroundSeoResponses,
  GetCityDetailData,
  GetCityDetailErrors,
  GetCityDetailResponses,
  GetCityTagsData,
  GetCityTagsErrors,
  GetCityTagsResponses,
  GetExperiencesData,
  GetExperiencesResponses,
  GetGeoTypeaheadData,
  GetGeoTypeaheadResponses,
  GetMovementTypesData,
  GetMovementTypesResponses,
  GetNearbyCitiesData,
  GetNearbyCitiesErrors,
  GetNearbyCitiesResponses,
  RemoveExperienceFromFavoriteData,
  RemoveExperienceFromFavoriteErrors,
  RemoveExperienceFromFavoriteResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Типы передвижения
 *
 * Справочник конкретных и сгруппированных типов передвижения экскурсий
 */
export const getMovementTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetMovementTypesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMovementTypesResponses, unknown, ThrowOnError>({
    url: '/api/movement-types/',
    ...options,
  });

/**
 * SEO данные для городов рядом
 *
 * Получение SEO данных для страницы городов рядом. Фильтры ids и source_ids взаимоисключающие.
 */
export const getCitiesAroundSeo = <ThrowOnError extends boolean = false>(
  options?: Options<GetCitiesAroundSeoData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCitiesAroundSeoResponses, GetCitiesAroundSeoErrors, ThrowOnError>({
    url: '/api/seo/v2/cities_around/',
    ...options,
  });

/**
 * Комментарии гидов к достопримечательности
 *
 * Список комментариев гидов к достопримечательности (для блока «Гиды рассказывают» в модалке)
 */
export const getAttractionComments = <ThrowOnError extends boolean = false>(
  options: Options<GetAttractionCommentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAttractionCommentsResponses, GetAttractionCommentsErrors, ThrowOnError>({
    url: '/api/web/v1/attractions/{id}/comments/',
    ...options,
  });

/**
 * Информация о городе
 *
 * Получение детальной информации о городе
 */
export const getCityDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCityDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCityDetailResponses, GetCityDetailErrors, ThrowOnError>({
    url: '/api/web/v1/cities/{slug}/',
    ...options,
  });

/**
 * Города рядом
 *
 * Получение списка городов рядом с указанным городом
 */
export const getCitiesAround = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesAroundData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCitiesAroundResponses, GetCitiesAroundErrors, ThrowOnError>({
    url: '/api/web/v1/cities/{slug}/around/',
    ...options,
  });

/**
 * Темы экскурсий города
 *
 * Получение списка тем/рубрик экскурсий города (для блока «Ещё темы экскурсий»)
 */
export const getCityTags = <ThrowOnError extends boolean = false>(options: Options<GetCityTagsData, ThrowOnError>) =>
  (options.client ?? client).get<GetCityTagsResponses, GetCityTagsErrors, ThrowOnError>({
    url: '/api/web/v1/citytags/',
    ...options,
  });

/**
 * Удалить экскурсию из избранного
 *
 * Удаление экскурсии из избранного текущего пользователя
 */
export const removeExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveExperienceFromFavoriteResponses,
    RemoveExperienceFromFavoriteErrors,
    ThrowOnError
  >({ url: '/api/web/v1/experiences/{id}/favorite/', ...options });

/**
 * Добавить экскурсию в избранное
 *
 * Добавление экскурсии в избранное текущего пользователя
 */
export const addExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddExperienceToFavoriteResponses, AddExperienceToFavoriteErrors, ThrowOnError>({
    url: '/api/web/v1/experiences/{id}/favorite/',
    ...options,
  });

/**
 * Экскурсии
 *
 * Список экскурсий (используется для блока экскурсий в модалке достопримечательности)
 */
export const getExperiences = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperiencesResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/',
    ...options,
  });

/**
 * Саджест городов
 *
 * Поиск городов по подстроке (typeahead)
 */
export const getGeoTypeahead = <ThrowOnError extends boolean = false>(
  options: Options<GetGeoTypeaheadData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetGeoTypeaheadResponses, unknown, ThrowOnError>({
    url: '/geo/typeahead/',
    ...options,
  });

/**
 * Города рядом (BFF)
 *
 * Получение города, списка городов рядом и SEO-данных
 */
export const getNearbyCities = <ThrowOnError extends boolean = false>(
  options: Options<GetNearbyCitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetNearbyCitiesResponses, GetNearbyCitiesErrors, ThrowOnError>({
    url: '/service/landings/api/bff/v1/nearby-cities/{slug}',
    ...options,
  });
